export const ROLE_SUPER_ADMIN = 'SuperAdministrator';
export const ROLE_SYSTEM_ADMIN = 'SystemAdministrator';

export class UserProfileViewModel {
  userId: number = 0;
  userName: string = '';
  userKey: string = '';
  userLanguage = 'en';
  companyLanguage = 'en';
  firstName: string = '';
  lastName: string = '';
  homePhoneNumber: string = '';
  workPhoneNumber: string = '';
  workMobilePhoneNumber: string = '';
  dateOfBirth?: Date;
  createDate?: Date;
  modifyDate?: Date;
  employeeNumber: string = '';
  employeeEmail: string = '';
  employeeId: number = 0;
  hasAccessToModule = false;
  companyHasAccessToModule = false;
  isSupervisor: boolean = false;
  companyId: number = 0;
  companyName?: string;
  teamId?: number;
  team?: string;
  userGroupId?: number;
  userGroup?: string;
  roles: string[] = [];
  actions: string[] = [];
  primaryAdminEmail: string = '';
}

export class UserProfileModel extends UserProfileViewModel {
  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  constructor(data?: UserProfileViewModel, forceLanguage?: string) {
    super();
    if (data) {
      Object.assign(this, data);
      this.userLanguage =
        (forceLanguage && forceLanguage.toLocaleLowerCase()) ||
        (this.userLanguage && this.userLanguage.toLocaleLowerCase());
      this.companyLanguage =
        data.companyLanguage && data.companyLanguage.toLocaleLowerCase();
      this.hasAccessToModule = this.hasAccessToModule === true;
      this.companyHasAccessToModule = this.companyHasAccessToModule === true;
    }
  }
}
